import './StringFilterView.less';
import React from "react";
import {translate} from "../../../../i18n";
import FilterViewTemplate from "../../templates/filter-view/FilterViewTemplate";


export default class StringFilterView extends React.Component {
    render() {
        const {fieldName, operator, value, requestEdit} = this.props;
        const isEmpty = value === '';
        const hasSpaceOffset = value.trim() !== value;
        const spacesPreservedValue = value.replace(/ /g, '\u00a0');

        return <div
            className={
                'string-filter-view'
                + (isEmpty ? ' is-empty' : '')
                + (hasSpaceOffset ? ' has-space-offset' : '')
            }
        >
            <FilterViewTemplate
                fieldName={fieldName}
                operator={operator}
                value={!isEmpty ? spacesPreservedValue : translate('(empty)')}
                valueLabel={!isEmpty ? spacesPreservedValue : undefined}
                requestEdit={requestEdit}
            />
        </div>;
    }
}
